import Stack from '@mui/material/Stack'

import { InstitutionLogo } from '@mxenabled/mxui'
import { Link } from '@mxenabled/mx-icons'

interface DiscoveredAccountsConnectProps {
  bottomIconAltText: string
  bottomIconInstitutionGuid: string
  topIconAltText: string
  topIconInstitutionGuid: string
}

const DiscoveredAccountsConnect = ({
  bottomIconAltText,
  bottomIconInstitutionGuid,
  topIconAltText,
  topIconInstitutionGuid,
}: DiscoveredAccountsConnectProps) => {
  return (
    <Stack
      sx={{
        alignItems: 'center',
        height: '100%',
        justifyContent: 'center',
        position: 'relative',
        width: '100%',
      }}
    >
      <Stack sx={{ bottom: '50%', position: 'absolute', right: '50%' }}>
        <InstitutionLogo alt={topIconAltText} institutionGuid={topIconInstitutionGuid} size={36} />
      </Stack>

      <Stack
        sx={{
          alignItems: 'center',
          borderRadius: '999px',
          height: 48,
          justifyContent: 'center',
          outline: '1px solid',
          outlineColor: 'divider',
          width: 48,
        }}
      >
        <Stack
          sx={{
            alignItems: 'center',
            bgcolor: 'secondary.light',
            borderRadius: '999px',
            height: 36,
            justifyContent: 'center',
            width: 36,
          }}
        >
          <Stack
            sx={{
              alignItems: 'center',
              bgcolor: 'secondary.main',
              borderRadius: '12px',
              height: 20,
              justifyContent: 'center',
              outline: '2px solid',
              outlineColor: 'primary.contrastText',
              width: 20,
              zIndex: 1,
            }}
          >
            <Link size={16} sx={{ color: 'primary.contrastText' }} />
          </Stack>
        </Stack>
      </Stack>

      <Stack sx={{ left: '50%', position: 'absolute', top: '50%' }}>
        <InstitutionLogo
          alt={bottomIconAltText}
          institutionGuid={bottomIconInstitutionGuid}
          size={36}
        />
      </Stack>
    </Stack>
  )
}

export default DiscoveredAccountsConnect
